import { css } from '@emotion/core';

import colors from '../config/colors';
import { mobileMediaQuery } from '../config/mediaQuery';


const dashboard = css`
  ${mobileMediaQuery} {
    .order-details-container {
      width: 90%;
      top: 151px;
      left: 16px;
      border-radius: 4px;
      box-shadow: 0px 4px 4px 1px #ACACAC40;
      margin: 20px auto;
    }
    .order-details-header {
      background-color: #F7F7F7;
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      padding: 16px;
      border: 0px 0px 1px 0px;
      border-bottom: 1px solid #EBEBEB;
      align-items: center;
      & p {
        margin: 0px;
        font-family: Lato;
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;
        text-overflow: ellipsis;
      }
    }
    .order-details-content {
      padding: 20px 10px 20px 20px;
      & p {
        font-family: Lato;
        font-size: 13px;
        font-weight: 600;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;
      }
    }
    .order-details-bottom {
      display: flex;
      flex-direction: row;
      justify-content: end;
      align-items: center;
      margin-top: 20px;
      padding: 16px;
      gap: 10px;
      background: linear-gradient(0deg, #EBEBEB, #EBEBEB),
      linear-gradient(0deg, #F7F7F7, #F7F7F7);
      border-bottom: 1px solid #EBEBEB;
      & p {
        margin: 0px;
        font-family: Lato;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;
      }
    }
    .order-empty-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      overflow: scroll;
      height: 500px;
      margin: 50px 0;
      .order-empty {
        height: 90%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .empty-title {
          font-family: Lato;
          font-size: 18px;
          font-weight: 500;
          line-height: 20px;
          letter-spacing: 0em;
          text-align: center;
          color: #000;
          margin-bottom: 20px;
        }
        .empty-message {
          font-family: Lato;
          font-size: 14px;
          font-weight: 400;
          line-height: 18px;
          letter-spacing: 0em;
          text-align: center;
          color: #6B7280;
          margin-bottom: 20px;
        }
        .empty-button {
          height: 44px;
          padding: 12px 16px 12px 16px;
          border-radius: 4px;
          gap: 10px;
          background-color: ${colors.mobileGreen};
          color: #fff;
          font-family: Lato;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          letter-spacing: 0em;
          border: none;
          width: 60%;
        }
      }

    }
    .order-empty-buttons {
      position: absolute;
      bottom: 0;
      width: 100%;
      display: flex;
      justify-content: space-between;
      height: 100px;
      background-color: white;
      z-index: 50;
      & button {
        width: 100%;
        background-color: transparent;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: none;
        gap: 10px;
        color: #9CA3AF;
      }
    }
    .order-details-empty {
      margin: auto;
      text-align: center;
      border-top: 1px solid #E5E7EB;
      padding: 30px 0;
      font-family: Lato;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: 0em;
      text-align: center;
      & p {
        color: black;
      }
      & a {
        display: block;
        margin: 20px 0px;
        font-family: Lato;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        letter-spacing: 0em;
        color: ${colors.mobileGreen};
      }
      & button {
        background-color: white;
        border: none;
        & span {
          display: none;
        }
      }
      & button::after {
        content: "Go to Item History";
        color: ${colors.mobileGreen};
        font-family: Lato;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: right;
      }
    }
    .action-menu-items {
      width: 100%;
      padding: 20px;
      & table {
        table-layout: fixed;
        width: 100%;
      }
      & tr {
        height: 48px;
      }
      & td {
        margin: auto;
        padding-bottom: 10px;
        text-align: left;
        width: 50%;
      }
      & button {
        background-color: white;
        border: none;
        font-family: Lato;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;
        color: #111827;
        & img {
          margin-right: 10px;
        }
      }
    }
    .action-menu-items-order {
      width: 100%;
      display: flex;
      justify-content: center;
      padding-top: 20px;
      & tbody {
        width: 100%;
      }
      & tr {
        height: 48px;
      }
      & td {
        margin: auto;
        padding-bottom: 10px;
        text-align: left;
        width: 50%;
      }
      & button {
        background-color: white;
        border: none;
        font-family: Lato;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;
        color: #111827;
        & img {
          margin-right: 10px;
        }
      }
    }
    .module-title {
      font-family: Lato;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: 0em;
      text-align: left;
      height: 44px;
      border-bottom: 1px solid #F0F0F0;
      padding: 12px 16px 12px 16px;
    }
    .module-title-with-subtitle {
      font-family: Lato;
      font-size: 14px;
      font-weight: 700;
      letter-spacing: 0em;
      text-align: left;
      padding: 12px 16px 0px 16px;
    }
    .module-subtitle {
      font-family: Lato;
      font-size: 14px;
      font-style: italic;
      letter-spacing: 0em;
      text-align: left;
      border-bottom: 1px solid #F0F0F0;
      padding: 0px 16px 12px 16px;
    }
    .module-menu-bar {
      width: 100%;
      height: 68px;
      backgroundColor: white;
      padding: 5px 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      & img {
        padding: 10px;
      }
    }
    .Toastify__toast-container {
      top: 90px;
      padding: 0 20px;
      .Toastify__toast--default {
        background: #35AF41 !important;
        border-radius: 4px;
        .Toastify__toast-body {
          color: white;
          font-family: Lato;
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          letter-spacing: 0.15000000596046448px;
          text-align: center;
        }
        .Toastify__close-button {
          color: white;
          opacity: 1;
          height: 46px;
        }
      }
      .Toastify__toast--error {
        background: #DC2626 !important;
        border-radius: 4px;
        .Toastify__toast-body {
          color: white;
          font-family: Lato;
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          letter-spacing: 0.15000000596046448px;
          text-align: center;
        }
        .Toastify__close-button {
          color: white;
          opacity: 1;
          height: 46px;
        }
      }
    }
    .actions-menu-top-section {
      border-bottom: 1px solid #F3F4F6;
      padding: 20px 20px 20px 20px;
      & div {
        font-size: 12px;
        letter-spacing: 0em;
        font-family: Lato;
      }
    }
    .restriction-field {
      border-bottom: 1px solid #F3F4F6;
      padding: 20px 20px 0 20px;
      .form-group {
        display: flex;
        align-items: center;
        width: 100%;
        label {
          font-family: Lato;
          font-size: 12px;
          font-weight: 400;
          letter-spacing: 0em;
          text-align: right;
          color: #000000;
          margin-right: 10px;
        }
        textarea {
          width: 100%;
          background: #EDF0F1;
          border: 1px solid #DDE4EB;
          border-radius: 4px;
          height: 32px;
        }
      }
    }
    .collapse-menu-button {
      font-family: Lato;
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      background: transparent;
      border: none;
      color: #111827;
      & img {
        padding: 0px;
        padding-right: 5px;
      }
    }
    .filter-clear-menu-button {
      font-family: Lato;
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      background: transparent;
      border: none;
      color: #CE1717;
      & img {
        padding: 0px;
        padding-right: 5px;
      }
    }
    .dropdown-menu {
      min-width: auto;
    }
    .wj-grouppanel {
      height: auto;
    }
    .wj-state-invalid {
      cursor: not-allowed;
      color: #bcbcbc;
      background: #f3f3f3;
    }
    .date-invalid {
      border-width: 2px;
      border-color: red;
    }
  }
`

export { dashboard }
